import { render, staticRenderFns } from "./mineCollection.vue?vue&type=template&id=7a3efd63&scoped=true&"
import script from "./mineCollection.vue?vue&type=script&lang=js&"
export * from "./mineCollection.vue?vue&type=script&lang=js&"
import style0 from "./mineCollection.vue?vue&type=style&index=0&id=7a3efd63&prod&scoped=true&lang=css&"
import style1 from "./mineCollection.vue?vue&type=style&index=1&id=7a3efd63&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3efd63",
  null
  
)

export default component.exports